import {useCallback, useEffect} from "react";
import {useBlocker} from "react-router-dom";

import {BmDialogModal} from "~/components/modals";
import {useOpenClose} from "~/hooks";
import {LOGIN_PATH} from "~/modules/routing";

type RouteLivingDialogProps = {
  when?: boolean | undefined;
  confirmButtonText: string;
  title?: string;
  content?: string;
};

export const RouteLeavingDialog: React.FC<RouteLivingDialogProps> = ({when, title, content, confirmButtonText}) => {
  const [isOpenModal, openModal, closeModal] = useOpenClose(false);

  const blocker = useBlocker(({currentLocation, nextLocation}) => {
    if (!when) return false;
    // Allow navigation to login
    if (nextLocation.pathname === LOGIN_PATH) return false;
    // Allow hash-only changes (same path, different hash)
    if (currentLocation.pathname === nextLocation.pathname && nextLocation.hash) return false;
    // Allow same path
    if (currentLocation.pathname === nextLocation.pathname) return false;
    // Block all other navigation
    return true;
  });

  const handleConfirmNavigationClick = useCallback(() => {
    closeModal();
    blocker.proceed?.();
  }, [closeModal, blocker]);

  const handleCloseModal = useCallback(() => {
    closeModal();
    blocker.reset?.();
  }, [closeModal, blocker]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      openModal();
    }
  }, [blocker.state, openModal]);

  return (
    <BmDialogModal
      open={isOpenModal}
      onClose={handleCloseModal}
      onConfirmButtonClick={handleConfirmNavigationClick}
      title={title}
      content={content}
      confirmButtonText={confirmButtonText}
    />
  );
};
